// extracted by mini-css-extract-plugin
export default {"wrapper":"src-components-InputPassword--wrapper","icon":"src-components-InputPassword--icon","iconEye":"src-components-InputPassword--iconEye"};